var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5078125,21.2080078l-2.3115234-4.6220703C26.0683594,16.328125,26,16.0400391,26,15.7539062V10 c0-5.5136719-4.4863281-10-10-10S6,4.4863281,6,10v5.7539062c0,0.2861328-0.0683594,0.5742188-0.1962891,0.8310547 l-2.3115234,4.6230469c-0.2285156,0.4580078-0.3496094,0.9697266-0.3496094,1.4804688 C3.1425781,24.5146484,4.6279297,26,6.4541016,26h19.0917969c1.8261719,0,3.3115234-1.4853516,3.3115234-3.3115234 C28.8574219,22.1777344,28.7363281,21.6660156,28.5078125,21.2080078z M25.5458984,24H6.4541016 c-0.7236328,0-1.3115234-0.5878906-1.3115234-1.3115234c0-0.2021484,0.0478516-0.4042969,0.1386719-0.5859375l2.3115234-4.6240234 C7.859375,16.9453125,8,16.3486328,8,15.7539062V10c0-4.4111328,3.5888672-8,8-8s8,3.5888672,8,8v5.7539062 c0,0.5947266,0.140625,1.1914062,0.4072266,1.7255859l2.3115234,4.6230469 c0.0908203,0.1816406,0.1386719,0.3837891,0.1386719,0.5859375C26.8574219,23.4121094,26.2695312,24,25.5458984,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-1.1025391,0-2-0.8974609-2-2h-2c0,2.2060547,1.7939453,4,4,4s4-1.7939453,4-4h-2 C18,29.1025391,17.1025391,30,16,30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSmall);
export default __webpack_public_path__ + "static/media/bell--small.a26b0de6005a12671a25688e28264edd.svg";
export { ForwardRef as ReactComponent };